import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import Grid from '../../../../grid/Grid';
import FieldSet from '../../../../fieldset/FieldSet';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import ArrayUtils from '../../../../../modules/ArrayUtils';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';

function GRPropertyTaxDetailedBill(props) {
  const { bill, } = props;

  const billItems = VerticalLabelList.toList({
    'External Account Id': bill.externalAccountId ?? '--',
    Year: bill.year ?? '--',
    'Due Date': moment(bill.dueDate)
      .utc()
      .format(),
    Paid: bill.isPaid,
    'Bill Balance': bill.billBalance_value ?? '--',
    'Client Bill Balance': bill.clientBillBalance_value ?? '--',
    'Pay It Balance': bill.payItBalance_value ?? '--',
    'Client Amount Paid': bill.clientAmountPaid_value ?? '--',
    'Total Tax Billed': bill.totalTaxBilled_value ?? '--',
    'Taxable Value': bill.taxableValue_value ?? '--',
    'Assessed Value': bill.assessedValue_value ?? '--',
    'Penalty Interest': bill.penaltyInterest_value ?? '--',
    'Last Payable Date': moment(bill.lastPayableDate).utc().format(),
    'Prior Year Delinquent': bill.priorYearDelinquent ?? '--',
    Season: bill.season ?? '--',
    'School District Code': bill.schoolDistrictCode ?? '--',
    'Winter Tax Included On Summer Bill': bill.winterTaxIncludedOnSummerBill ?? '--',
    'For Customized Use': bill.forCustomizedUse ?? '--',
    'Bank Code': bill.bankCode ?? '--',
    'Bank Name': bill.bankName ?? '--',
    'External Bill Id': bill.externalBillId ?? '--',
    'Pre or MBT Percent': bill.preOrMbtPercent ?? '--',
    'Special Assessment Flag': bill.specialAssessmentFlag ?? '--',
    'Unpaid 2017 Bill': bill.unpaid2017Bill ?? '--',
    'Payment Time Zone': bill.paymentTimeZone ?? '--',
    'Account Id': bill.accountId ?? '--',
    Id: bill.id ?? '--',
  });

  const options = {};
  const paymentTransactions = ObjectUtils.formatStringAsJSONArray(bill.paymentTransactions);
  const flatPmtTxns = ArrayUtils.selectivelyFlattenJSONArrayObjects(paymentTransactions);

  options.headerFormatter = object => _.startCase(object.header);

  const paymentTransactionModel = Grid.toModelFromList(flatPmtTxns, options);

  return (
    <div style={{ height: '100%', fontSize: '20px', }}>
      <FieldSet title="Bill Summary">
        <VerticalLabelList items={billItems} />
      </FieldSet>
      <div style={{ paddingTop: '10px', }}>
        <FieldSet title="Payment Transactions">
          <Grid
            headers={paymentTransactionModel.headers}
            rows={paymentTransactionModel.format(paymentTransactions)}
            onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
          />
        </FieldSet>
      </div>
    </div>
  );
}

GRPropertyTaxDetailedBill.propTypes = {
  bill: PropTypes.instanceOf(Object).isRequired,
};

export default GRPropertyTaxDetailedBill;
